var $f00cafd61c2e1654$exports = {};
const $f00cafd61c2e1654$var$dataStart = document.querySelector('button[data-start]');
const $f00cafd61c2e1654$var$dataStop = document.querySelector('button[data-stop]');
const $f00cafd61c2e1654$var$bodyEl = document.querySelector('body');
let $f00cafd61c2e1654$var$timerId = null;
$f00cafd61c2e1654$var$dataStop.setAttribute('disabled', true);
function $f00cafd61c2e1654$var$getRandomHexColor() {
    return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, 0)}`;
}
$f00cafd61c2e1654$var$dataStart.addEventListener('click', ()=>{
    $f00cafd61c2e1654$var$dataStop.removeAttribute('disabled');
    $f00cafd61c2e1654$var$timerId = setInterval(()=>{
        const color = $f00cafd61c2e1654$var$getRandomHexColor();
        $f00cafd61c2e1654$var$bodyEl.style.backgroundColor = color;
    }, 1000);
    $f00cafd61c2e1654$var$dataStart.setAttribute('disabled', true);
});
$f00cafd61c2e1654$var$dataStop.addEventListener('click', ()=>{
    $f00cafd61c2e1654$var$dataStart.removeAttribute('disabled');
    clearInterval($f00cafd61c2e1654$var$timerId);
    $f00cafd61c2e1654$var$dataStop.setAttribute('disabled', true);
});


//# sourceMappingURL=01-color-switcher.a9aaf5c4.js.map
